import React from 'react';
import classnames from 'classnames';

// Constants
import ExternalLinksConstants from 'Shared/constants/ExternalLinks.constants';

// Hooks
import { useApp } from 'Shared/utils/hooks/use-app';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

// Styles
import './SignUpTermsAgreement.scss';

type Props = {
  className?: string;
  prefixText?: string;
};

const SignUpTermsAgreement = ({ prefixText = undefined, className }: Props) => {
  const { isZoom } = useApp();
  const { tr } = useTranslation();

  const handleTermsOfServiceClick = event => {
    if (isZoom) {
      event.preventDefault();
      (window as any).zoomSdk.openUrl({ url: `${window.location.origin}/terms_of_service` });
    }
  };

  const handlePrivacyPolicyClick = event => {
    if (isZoom) {
      event.preventDefault();
      (window as any).zoomSdk.openUrl({ url: `${window.location.origin}/privacy_policy` });
    }
  };

  const baseClassName = 'SignUpTermsAgreement';
  const classes = classnames(baseClassName, className);
  const effectivePrefixText = prefixText ?? tr('perform.auth.signup.agreement.prefix_default');

  return (
    <p className={classes}>
      {effectivePrefixText}, {tr('perform.auth.signup.agreement.you_agree_to')}{' '}
      <a
        href={ExternalLinksConstants.terms_of_service}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleTermsOfServiceClick}
      >
        {tr('perform.auth.signup.agreement.terms_of_service')}
      </a>{' '}
      {tr('perform.auth.signup.agreement.and')}{' '}
      <a
        href={ExternalLinksConstants.privacy_policy}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handlePrivacyPolicyClick}
      >
        {tr('perform.auth.signup.agreement.privacy_policy')}
      </a>
      .
    </p>
  );
};

export default SignUpTermsAgreement;
